import { useStores } from "stores/rootStore";
import { safeLocalStorage } from "helpers/localStorage";
import { CartItem } from "stores/marketPlaceStore";
import { useEffectOnce } from "react-use";

const getCartFromLocalStorage = (cartId: string) => {
  const cart = safeLocalStorage.getItem(cartId);
  if (cart == null) {
    return null;
  }
  return JSON.parse(cart) as CartItem[];
};

export const useGetCart = (cartId: string) => {
  const { marketPlaceStore } = useStores();
  const cart = getCartFromLocalStorage(cartId);
  if (cart == null) {
    return marketPlaceStore.cart;
  }
  return cart;
};

export const useInitCart = () => {
  const { marketPlaceStore } = useStores();

  useEffectOnce(() => {
    const cartId = safeLocalStorage.getItem("cartId");
    if (cartId == null) {
      return;
    }
    marketPlaceStore.setCartId(cartId);
    const cart = getCartFromLocalStorage(cartId);
    if (cart == null) {
      return;
    }
    for (const item of cart) {
      marketPlaceStore.addToCart(item);
    }
  });
};
